const Designer = {
  state: {
    current: 0,
    templates: {}
    /**
     * groups: [
     *   {
     *     parameters: [
     *       {
     *         id: 1,
     *         ps_attribute_name: '',
     *       }
     *     ]
     *   }
     * ]
     */
  },
  getters: {
    getTemplates: (state) => state.templates,
    getGroups: (state) => {
      if (!state.templates[state.current]) {
        return []
      }
      return state.templates[state.current].groups
    },
    getAvailableFabrics: (state, getters) => {
      const groups = getters.getGroups
      if(!groups) {
        return {}
      }

      const fabrics = groups.find(group => group.parameters[0].code === 'TISSU');
      if(!fabrics) {
        return {};
      }

      const availables = {};

      fabrics.parameters[0].values.forEach((f) => {
        availables[f.code] = f;
      });

      return availables;
    },
    // todo: add getters for group, tissus, ...
  },
  actions: {
    setTemplates({ commit }, templates) {
      commit('SET_TEMPLATES', templates)
    }
  },
  mutations: {
    SET_TEMPLATES(state, templates) {
      state.templates = templates
    }
  }
}

export default Designer



// WEBPACK FOOTER //
// ./src/store/modules/designer.js